import { render, staticRenderFns } from "./OpenInvoices.vue?vue&type=template&id=2e41c8a1&scoped=true"
import script from "./OpenInvoices.vue?vue&type=script&lang=ts"
export * from "./OpenInvoices.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e41c8a1",
  null
  
)

export default component.exports